import { PROJECT_TEMPLATE, ProjectProps } from "@/interfaces/project_types"
import { isValidStatus } from "../Utils/isValidStatus"
import { ProjectFormSchema } from "./DefaultSchema"
import { z } from "zod"

/* This does the conversion from the ProjectProps to the ProjectFormSchema
Used for updating projects where props are passed in
*/
export function ImportFormProps({formProps}: {formProps?: ProjectProps}) {
    if (!formProps) return {}
    return {
        project_name: formProps.project_name,
        status: isValidStatus(formProps.status) ? {
            value: formProps.status,
            label: formProps.status,
        } : {
            value: "Active" ,
            label: "Active",
        },
        start_date: formProps.start_date,
        end_date: formProps.end_date,
        follow_up_date: formProps.follow_up_date,
        manager: formProps.manager ? {
            value: formProps.manager.email,
            label: formProps.manager.name,
        } : undefined,
        city: formProps.city ? {
            value: formProps.city,
            label: formProps.city,
        } : undefined,
        description: formProps.description ?? "",
        // The extra check is because since Client is optional, it might return an empty string
        client_name: formProps.client && formProps.client.name !== "" ? {
            value: formProps.client.uuid,
            label: formProps.client.name,
        } : undefined,
        isDeadline: formProps.isDeadline ?? false,
        // The extra check is because since POC is optional, it might return an empty string
        point_of_contact: formProps.poc && formProps.poc.name !== "" ? {
            value: formProps.poc.uuid,
            label: formProps.poc.name,
        } : undefined,
        template: formProps.template ? PROJECT_TEMPLATE.find(template => template.value === formProps.template) : PROJECT_TEMPLATE[0],
        no_date_due: formProps.no_date_due ?? false,
        project_size: formProps.project_size ?? 0,
        consulting_fee: formProps.consulting_fee ?? 0,
        folder_location: formProps.folder_location ?? "",
    } as z.infer<typeof ProjectFormSchema>
}

